<script lang="ts">
  import {onMount} from 'svelte'
  import {_} from 'svelte-i18n'
  import {getWikiList, initWikiPublications} from './services'
  import {countByGroup, info_client, isDirtySearch, isShowSearchLoader, list} from "../../stores";
  import WikiPublicationsCuratorsFilters
    from './components/WikiPublicationsCuratorsFilters/WikiPublicationsCuratorsFilters.svelte'
  import WikiPublicationsInfiniteScroll
    from './components/WikiPublicationsInfiniteScroll/WikiPublicationsInfiniteScroll.svelte'
  import WikiPublicationsPreviewCards
    from './components/WikiPublicationsPreviewCards/WikiPublicationsPreviewCards.svelte'
  import WikiPublicationsLoader from './components/WikiPublicationsLoader/WikiPublicationsLoader.svelte'
  import GeneralLayout from '../../layouts/GeneralLayout.svelte'
  import NewslineAllViewModal from '../Newsline/components/NewslineAllViewModal/NewslineAllViewModal.svelte';
  import GlobalSearchInfo from "../../custom/GlobalSearch/GlobalSearchInfo.svelte";
  import GlobalSearch from "../../custom/GlobalSearch/GlobalSearch.svelte";
  import GlobalSearchTags from "../../custom/GlobalSearch/GlobalSearchTags.svelte";
  import WikiPublicationsNoItemsBanner
    from "./components/WikiPublicationsNoItemsBanner/WikiPublicationsNoItemsBanner.svelte";
  import ContentTitle from '../../custom/ContentTitle.svelte';

  let listPT = []
  let listRPP = []
  let listWiki = []
  let wikiByFolders = []
  let searchResults = []

  let currentWikiFolder: string | null = null;

  $: listPT = $list.filter(el => !el.wiki_page && el.feed_group.slug === 'physical_transformation')
  $: listRPP = $list.filter(el => !el.wiki_page && el.feed_group.slug === 'physical_rpp')
  $: listWiki = $list.filter(el => el.wiki_page)
  $: wikiByFolders = listWiki.reduce((acc, el) => {
    const title = el.wiki_page.title;
    if (!acc[title]) {
      acc[title] = [];
    }
    acc[title].push(el);
    return acc;
  }, {})
  $: searchResults = [
    {
      list: wikiByFolders,
      count: $countByGroup?.wiki,
      order: 1,
      title: $_('PhTWiki')
    },
    {
      list: listPT,
      count: $countByGroup?.physical_transformation,
      order: 2,
      title: 'Physical Transformation'
    },
    $info_client.is_paid_rpp_current_flow &&
    {
      list: listRPP,
      count: $countByGroup?.rpp,
      order: 3,
      title: 'Physical Psychology'
    },
  ]

  $: {
    if ($isDirtySearch) {
      currentWikiFolder = null;
    } else {
      currentWikiFolder = Object.keys(wikiByFolders)[0];
    }
  }

  const search = async () => {
    list.set([])

    await getWikiList()

    isShowSearchLoader.set(false)
  }

  onMount(initWikiPublications)
</script>

<GeneralLayout>
  <WikiPublicationsCuratorsFilters/>
  <GlobalSearch on:search={search}/>
  <GlobalSearchTags on:search={search}/>

  {#if $isDirtySearch}
    <GlobalSearchInfo searchResults={searchResults}/>
  {:else}
    <ContentTitle title={$_('PhTWiki')} folder={currentWikiFolder} />
    <WikiPublicationsPreviewCards/>
    <WikiPublicationsNoItemsBanner/>
  {/if}
  <WikiPublicationsLoader/>
</GeneralLayout>

<WikiPublicationsInfiniteScroll/>
<NewslineAllViewModal/>